import React, { useState, useEffect } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Chip,
    Box,
    Alert,
    CircularProgress,
    colors,
} from '@mui/material';
import axiosInstance from '../utills/axiosInstance';
import moment from 'moment';

const MyODRequests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const profile = JSON.parse(localStorage.getItem('profile') || '{}');
    const empId = profile.empId;

    useEffect(() => {
        if (!empId) {
            setError('Employee ID not found');
            setLoading(false);
            return;
        }
        fetchMyODs();
    }, [empId]);

    const fetchMyODs = async () => {
        setLoading(true);
        setError('');
        try {
            const res = await axiosInstance.get(`/api/od/pending?empId=${empId}`);
            setRequests(res.data || []);
        } catch (err) {
            setError('Failed to load your OD requests');
        } finally {
            setLoading(false);
        }
    };

    const getStatusChip = (status) => {
        const colorMap = {
            Pending: 'warning',
            Approved: 'success',
            Rejected: 'error'
        };
        return <Chip label={status} color={colorMap[status] || 'default'} size="small" />;
    };

    return (
        <Paper sx={{ p: 4, borderRadius: 2, boxShadow: 3 }}>
            <Typography variant="h5" textAlign="center" mb={4}>
                My On Duty (OD) Requests
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
                    <CircularProgress />
                </Box>
            ) : requests.length === 0 ? (
                <Alert severity="info">You have no OD requests</Alert>
            ) : (
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell><strong style={{ color: 'black' }}>Date</strong></TableCell>
                                <TableCell><strong style={{ color: 'black' }}>Reason</strong></TableCell>
                                <TableCell><strong style={{ color: 'black' }}>Allowances</strong></TableCell>
                                <TableCell><strong style={{ color: 'black' }}>Status</strong></TableCell>
                                <TableCell><strong style={{ color: 'black' }}>Comments</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {requests.map((od) => (
                                <TableRow key={od._id} hover>
                                    <TableCell>
                                        {moment(od.date).format('ddd, MMM DD, YYYY')}
                                    </TableCell>
                                    <TableCell>
                                        {od.reason || <em>No reason provided</em>}
                                    </TableCell>
                                    <TableCell>
                                        {od.allowances?.enabled ? (
                                            <>
                                                {od.allowances.food?.amount > 0 && (
                                                    <Chip label={`Food: ₹${od.allowances.food.amount}`} size="small" color="success" sx={{ mr: 1 }} />
                                                )}
                                                {od.allowances.fuel?.amount > 0 && (
                                                    <Chip label={`Fuel: ₹${od.allowances.fuel.amount}`} size="small" color="primary" />
                                                )}
                                            </>
                                        ) : (
                                            <Chip label="None" size="small" />
                                        )}
                                    </TableCell>
                                    <TableCell>{getStatusChip(od.status)}</TableCell>
                                    <TableCell>
                                        {od.approverComments || <em>No comments</em>}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Paper>
    );
};

export default MyODRequests;
